/**
 * Location display helpers for the public storefront.
 *
 * State normalization: owners sometimes type a state as "Il" or "Il." — which
 * rendered verbatim on the public site (e.g. "Granite City, Il."). This cleans
 * a 2-letter US state to uppercase and drops a trailing period, at RENDER time,
 * so already-stored values display correctly without a data migration. Longer
 * values (full state names, non-US regions) are returned trimmed, untouched.
 */
export function formatState(state) {
    const s = String(state || '').trim().replace(/\.+$/, '').trim();
    if (s.length === 2 && /^[A-Za-z]{2}$/.test(s)) return s.toUpperCase();
    return s;
}

/**
 * Join a city and (normalized) state as "City, ST". Omits empty parts so a
 * missing state doesn't leave a dangling comma.
 */
export function formatCityState(city, state) {
    return [String(city || '').trim(), formatState(state)].filter(Boolean).join(', ');
}
